import Lottie from 'lottie-react';
import loadingAnimation from '../../assets/animations/loading.json';
import React from 'react';
import './site-loader.scss';

const SiteLoader = () => {
  return (
    <div className={'site-loader'}>
      <Lottie animationData={loadingAnimation} loop={true} className={'site-loader__animation'} />
    </div>);
};
export default SiteLoader;
